import React from 'react';
import {makeStyles} from "@material-ui/styles";
import {RTL,AlertDialog} from "../../../../components";
import {Typography,Button} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import withStyles from "@material-ui/core/styles/withStyles";
import { showSnackbar } from 'redux/Action';
import { useDispatch, useSelector } from 'react-redux';
import { axios } from './../../../../axios';

const useStyles = makeStyles(theme => ({
    dialogTitle:{
        '& > h2':{
            fontWeight:'bold'
        }
    },
    formControl:{
        marginTop:theme.spacing(4)
    }
}));

const ColorButton = withStyles(theme => ({
    root: {
        color: theme.palette.getContrastText( '#EC4E4F'),
        backgroundColor: '#EC4E4F',
        '&:hover': {
            backgroundColor: '#e51212',
        },
    },
}))(Button);

const DeleteDialog= props=> {
    const classes=useStyles();
    const {open,onClose,onAccept,reloadFunc,desc,id}=props;



    const dispatch = useDispatch();

    const token = useSelector((state) => state.token);
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
  
  
    const DeleteShipment = async () => {
      
          try{
              const res = await axios.delete(`shipments/${id}`, {
                headers: headers,
              });
              dispatch(showSnackbar(true,'success','بار با موفقیت حذف شد'))
              reloadFunc();
              onClose();
        
            }catch(e)
            {
              console.log(e.response,"eeeeeeeee")
             
            }
      
      
    
  }



    return (
        <RTL>
            <AlertDialog
                fullWidth={true}
                onClose={onClose}
                onAccept={onAccept}
                maxWidth={'sm'}
                onAcceptText={    <ColorButton
                    variant="contained"
                    onClick={() => DeleteShipment()}

                    className={classes.button}
                >
                    <DeleteIcon style={{marginLeft:'8px'}} />
                    حذف
                </ColorButton>}
                onCloseText={
                    <Typography style={{color:'#aaa'}} variant="body1">
                        <b>
                            لفو
                        </b>
                    </Typography>
                }
                title="حذف بارنامه" open={open}>
                <Typography variant="body1">
                    آیا بارنامه
                    <b> {desc.map((c) => (c.origin?.name+"-"+c.destination?.name))} </b>
                    حذف شود؟
                </Typography>
            </AlertDialog>
        </RTL>
    );
};

export default DeleteDialog;